var React = require( 'react' );
var createReactClass = require('create-react-class');

var PageEditor = createReactClass( {
    handleChange: function(e, subfield) {
        this.props.handleChange(e, subfield);
    },

	render: function () {
        const { isActive, section, friendlyUrl, title, displayName, meta } = this.props;
        return (
            <div>
                <h3>Page details</h3>
                <div className="input-field">
                    <label htmlFor="title" className="heading">Is page active?</label>
                    <input type="checkbox" id="isActive" name="isActive" checked={isActive} onChange={(e) => this.handleChange(e)} />
                </div>
                <div className="input-field">
                    <label htmlFor="title" className="heading">Page title</label>
                    <input type="text" id="title" name="title" defaultValue={title} onChange={(e) => this.handleChange(e)} />
                </div>
                <div className="input-field">
                    <label htmlFor="menu-name" className="heading">Menu item title*</label>
                    <input type="text" id="menu-name" name="displayName" required defaultValue={displayName} onChange={(e) => this.handleChange(e)} />
                </div>
                <label htmlFor="friendly-url" className="heading">Friendly Url*</label>
                <div className="input-group">
                    <span className="input-group-label">{section}/</span>
                    <input className="input-group-field" type="text" id="friendly-url" name="newFriendlyUrl" required defaultValue={friendlyUrl} onChange={(e) => this.handleChange(e)} />
                </div>
                <div className="input-field">
                    <label htmlFor="meta-title" className="heading">SEO - Meta title</label>
                    <input type="text" id="meta-title" name="title" defaultValue={meta && meta.title} onChange={(e) => this.handleChange(e, 'meta')} />
                </div>
                <div className="input-field">
                    <label htmlFor="meta-description" className="heading">SEO - Meta description</label>
                    <input type="text" id="meta-description" name="description" defaultValue={meta && meta.description} onChange={(e) => this.handleChange(e, 'meta')} />
                </div>
            </div>
        );
	}
});

module.exports = PageEditor;


// WEBPACK FOOTER //
// ./src/common/routes/education/components/layout/pageEditor.jsx